'use client'

import { Drawer, DrawerBody, DrawerContent } from '@heroui/drawer'
import { useDisclosure } from '@heroui/react'
import { Menu } from 'lucide-react'

export function ProfileDrawer({ children }: { children: React.ReactNode }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <button className='cursor-pointer' onClick={onOpen}>
        <Menu />
      </button>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement='left'
        size='sm'
        radius='sm'
      >
        <DrawerContent>
          <DrawerBody>{children}</DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}
